import { speakersDemo } from "~/components/marketing/demo";
import { SpeakersMockup } from "~/components/marketing/mockups";
import { SplitRow } from "~/components/marketing/ui";
import { useI18n } from "~/i18n";

export const SpeakersSection = () => {
  const { t } = useI18n();
  return (
    <SplitRow
      id="home-speakers"
      index="02"
      eyebrow={t("marketing.home.speakers.eyebrow")}
      title={t("marketing.home.speakers.title")}
      body={t("marketing.home.speakers.body")}
      link={{ href: "/features#speakers", label: t("marketing.home.see_how") }}
      visual={<SpeakersMockup data={speakersDemo(t)} />}
    />
  );
};
